import {lazy, Suspense} from 'react';
import Skeleton from '@mui/material/Skeleton';
import {Typography} from '@mui/material';

const LazyPropertyInsightsAug2020 = lazy(() => import('./PropertyInsightsAug2020'));

const FallbackRender = (
  <div className={'PropertyInsightsAug2020'}>
    <Typography variant="h6">
      <Skeleton variant="text" width="35%"/>
    </Typography>
    <div className="line"/>
    <Skeleton variant="rectangular" height={50} />
    <Skeleton variant="rectangular" height={110} width="30%" />
  </div>
);

const PropertyInsightsAug2020 = props => (
  <Suspense fallback={FallbackRender}>
    <LazyPropertyInsightsAug2020 {...props} />
  </Suspense>
);

export default PropertyInsightsAug2020;
